import { Component, OnInit, ChangeDetectorRef, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { SubmitButtonClickService } from 'src/app/services/submit-button-click.service';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Messages } from 'src/app/constants/messages';
import { Utilities } from 'src/app/constants/utilities';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-users-modal',
  templateUrl: './users-modal.component.html',
  styleUrls: ['./users-modal.component.css'],

})
export class UsersModalComponent implements OnInit, OnDestroy {

  @Input() userData: any;
  @Input() userAdd: any;
  @Input() userView: any;
  @Input() userEdit: any;
  @Input() userValidate: any;
  @Input() userReValidate: any;

  userForm: FormGroup;
  selectedIndex: number = 0;
  userSubmitted: boolean = false;
  // searchSelection: any = "5f9aab55c218ff12938c251f";
  roleList: any = [];
  tradeList: any = [];
  isRevoke: boolean = true;
  showSupervisor: boolean = false

  /*user Credentials */
  disableAvailableCheck: boolean = true;
  userNameAvailable: any = null;
  showText: any = 'Check Availability';
  toggle: boolean = false;
  userGroupList: any = [];
  errorMsg: any;
  plantList: any[] = [];
  supervisorList: any[] = [];

  private _loading: boolean = false;
  private _status: boolean = false;
  private _closeModalAfterClosedSubscription: Subscription;
  private _deleteAfterClosedSubscription: Subscription;
  private _availableUsernameSubscription: Subscription;
  private _onResetAfterClosedSubscription: Subscription;
  private _resetPasswordSubscription: Subscription;
  private _onResetRevokeAfterClosedSubscription: Subscription;
  private _revokePasswordSubscription: Subscription;
  private _getSiteListSubscription: Subscription;
  private _availableSupervisorsSubscription: Subscription;
  private _updateImageSubscription: Subscription;
  private _createUserSubscription: Subscription;
  private _afterClosedSubscription: Subscription;
  private _editUserSubscription: Subscription;
  private _roleListSubscription: Subscription;
  private _tradeListSubscription: Subscription;
  private _userGroupPeopleSubscription: Subscription;

  
  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _submitButtonClick: SubmitButtonClickService,
    private _service: ServicecallService,
    private _cd: ChangeDetectorRef,
    private _dialog: MatDialog,
  ) {
    this.userForm = this._fb.group({
      name: [""],
      empId: [this.userData ? this.userData.empId : null, [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      personalInfo: [""],
      contact: [""],
      userName: ["", [Validators.required,this._validateUsername()]],
      idmUserName: [""],
      userGroup: [""],
      image: [""],
      remarks: [""],
      roleId: ["", [Validators.required]],
      tradeId: ["", [Validators.required]],
      siteId: [''],
      supervisor: [''],
      restrictedAccess: [false]
    });

  }


  ngOnInit(): void {
    this._loadPeopleModalData();
    this._getRoleList();
    this._getTradeList();
    this._getUserGroup();
    this._getPlants();
    if (!this.userEdit) {
      this._checkselectedPlant();
    }
  }
  ngOnDestroy(): void {
    this._closeModalAfterClosedSubscription?.unsubscribe(); 
    this._deleteAfterClosedSubscription?.unsubscribe();  
    this._availableUsernameSubscription?.unsubscribe();  
    this._onResetAfterClosedSubscription?.unsubscribe();  
    this._resetPasswordSubscription?.unsubscribe();  
    this._onResetRevokeAfterClosedSubscription?.unsubscribe(); 
    this._revokePasswordSubscription?.unsubscribe();  
    this._getSiteListSubscription?.unsubscribe();  
    this._availableSupervisorsSubscription?.unsubscribe();  
    this._updateImageSubscription?.unsubscribe();  
    this._createUserSubscription?.unsubscribe();  
    this._afterClosedSubscription?.unsubscribe();  
    this._editUserSubscription?.unsubscribe();  
    this._roleListSubscription?.unsubscribe();  
    this._tradeListSubscription?.unsubscribe();  
    this._userGroupPeopleSubscription?.unsubscribe();  
  }
  showSupervisorList(event: any) {
    if (event.isUserInput) {
      this.userForm.patchValue({ siteId: event?.source?.value });
      this.showSupervisor = true;
      this._getSupervisorList();
    }
  }

  closeModal() {
    if (!this.userForm.value['contact'].number && !this.userForm.value['contact'].email)
      this.userForm.controls['contact'].markAsPristine();
    if (!this.userSubmitted && this.userForm.dirty) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: Messages.UNSAVED_CHANGES, type: null },
        disableClose: true
      });
      this._closeModalAfterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._activeModal.close();
          this.userForm.reset();
        }
      });
    } else {
      this._activeModal.close()
      this.userForm.reset();
    }
  }
  onImageSelected(event: any) {
    const imageType = event.target.files[0] ? event.target.files[0].type : null;
    if (imageType.includes('image/')) {
      this._sasUrl = null;
      this._thumbnail = null;
      let img: File;
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.imgURL = reader.result;
      };
      img = event.target.files[0]
      this._imageUpload(null, null, img, null, false)
      this._cd.markForCheck();
    } else {
      this._service.toasterService({ type: Messages.ERROR, msg: 'Please upload any valid image type' });
      return;
    }
  }
  deleteImage() {
    let dialogRef = this._dialog.open(AlertDialogComponent, {
      data: { msg: Messages.IMAGE_DELETE, type: null },
      panelClass: 'custom-alert-dialog',
      disableClose: true
    });
    this._deleteAfterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let relativePath: any;
        let recordId: any;
        let type: any;
        if (typeof (this.userForm.value.image) === 'string') {
          let image = this.userForm.value.image;
          if (this._sasUrl == null) {
            type = 1;
            relativePath = this.userData?.image?.split("?")[0].split("/").slice(-3).join('/');
            recordId = this.userData?._id;
          }
          else {
            type = null;
            relativePath = this._sasUrl.split("?")[0].split("/").slice(-3).join('/');
            recordId = null;
          }
        }
        else {
          this.userForm.value.image = null;
          this.imgURL = null
        }
        this._imageUpload(relativePath, type, null, recordId, true);
      }
    });
  }
  onSubmit(action: any) {
    if (this.userData) {
      this._editUser(action);

    } else {
      this._saveUser();
    }
  }
  checkUsername(event: any) {
    if (event.target.value) {
      this.toggle = true;
      this.userForm.patchValue({ userName: event.target.value })
      this.userForm.controls['userGroup'].setValidators([Validators.required]);
      this.userForm.controls['userGroup'].updateValueAndValidity();
    } else {
      this.toggle = false;
      this.userForm.patchValue({ userName: null })
      this.disableAvailableCheck = true;
      this.showText = 'Check Availability';
      this.userNameAvailable = null;
      this.userForm.controls['userGroup'].clearValidators();
      this.userForm.controls['userGroup'].updateValueAndValidity();
    }

  }

  checkidmUserName(event: any) {
    if (event.target.value) {
      this.userForm.patchValue({ idmUserName: event.target.value })
    } else {
      this.userForm.patchValue({ idmUserName: null });
    }
  }

  checkAvailablility() {
    this._status = true;
    this._availableUsernameSubscription = this._service.availableUsername(this.userForm.value.userName).subscribe((res: any) => {
      if (res['status']) {
        this.showText = 'Available!'
        this.userNameAvailable = true;

      } else {
        this.showText = 'Already in use'
        this.userNameAvailable = false;
      }
    })
  }
  
  stepChange(changeType: any) {
    if (changeType === 'next' && this.selectedIndex < 5) {
      this.selectedIndex = this.selectedIndex + 1;
    } else if (changeType === 'previous' && this.selectedIndex > -1) {
      this.selectedIndex = this.selectedIndex - 1;
    }
  }
  
  onTabChange(event: any) {
    this.selectedIndex = event.index;
  }

  onResetRevoke(eventType: any) {
    if (eventType === 'reset') {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: Messages.RESET_PASSWORD, type: null },
        panelClass: 'custom-alert-dialog',
        disableClose: true
      });
      const reqPayload = {
        ...(this.userData.credentials[0].userName && {userName: this.userData.credentials[0].userName})
      }
      this._onResetAfterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._resetPasswordSubscription = this._service.resetPassword(reqPayload).subscribe((resp: any) => {
            if (resp['status']) {
              if (resp['response']) {
                this._service.toasterService({ type: 'success', msg: resp["response"]["message"] });
              }
            } else {
              this._service.toasterService({ type: 'error', msg: resp["response"]["message"] });
            }
          });
        }
      })
    } else if (eventType === 'revoke') {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: Messages.REVOKE_PASSWORD, type: null },
        panelClass: 'custom-alert-dialog',
        disableClose: true
      });
      this._onResetRevokeAfterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._revokePasswordSubscription = this._service.revokePassword(this.userData._id).subscribe((resp: any) => {
            if (resp['status']) {
              this.isRevoke = true;
              this.userForm.controls["userName"].enable();
              this.userForm.patchValue({ userName: null, userGroup: null });
              this.userData['credentials'] = [];
              if (resp['response']) {
                this._service.toasterService({ type: 'success', msg: resp["response"]["message"] });
              }
            } else {
              this._service.toasterService({ type: 'error', msg: resp["response"]["message"] });
            }
          });
        }
      });
    }
  }

  omit_special_char(event: any) {
    const k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  private _checkselectedPlant() {
    const siteId = sessionStorage.getItem('siteId') ?
      JSON.parse(sessionStorage.getItem('siteId') || '{}') : null;
    if (siteId) {
      this.userForm.patchValue({ siteId: siteId });
      this.userForm.controls['siteId'].disable();
      this.showSupervisor = true;
      this._getSupervisorList();
    }
  }

  get userFormValues() {
    return this.userForm.controls;
  }

  private _getPlants() {
    this._getSiteListSubscription = this._service.getSiteList().subscribe((result: any) => {
      if (result['status']) {
        if (result['response'] && result['response']['data'].length) {
          this.plantList = result['response']['data'];
        } else {
          this.plantList = [];
        }
      }
    });
  }

  private _getSupervisorList() {
    const reqData = {
      entityId: this.userData?._id ? this.userData?._id : null,
      siteId: this.userForm.controls['siteId'].value
    }
    this._availableSupervisorsSubscription = this._service.availableSupervisors(reqData).subscribe((result: any) => {
      if (result['status']) {
        if (result['response'] && result['response']['data'].length) {
          this.supervisorList = result['response']['data'];
        }
      }
      else {
        this.supervisorList = [];
        this._service.toasterService({ type: 'error', msg: result["response"]["message"] });
      }
    });
  }
 
  imgURL: any = null;
  private _sasUrl: any = null;
  private _thumbnail: any = null;
 
  private _imageUpload(relativePath: any, type: any, img: any, recordId: any, del?: any) {
    this._updateImageSubscription = this._service.updateImage(relativePath, type, img, recordId).subscribe((res: any) => {
      if (res['status']) {
        this.userForm.value.image = null;
        this.imgURL = null
        if (!del) {
          if (res['response']['sasUrl']) {
            this._sasUrl = res['response']['sasUrl'];
            this.userForm.patchValue({ image: this._sasUrl })
            this.imgURL = this._sasUrl
          }
          if (res['response']['thumbnail']) {
            this._thumbnail = res['response']['thumbnail']
          }
        }
        else {
          this._sasUrl = null
          this._thumbnail = null
          this.imgURL = null
          this.userForm.patchValue({ image: this._sasUrl })
        }
      } else {
        this.imgURL = null;
        this._sasUrl = null
        this._thumbnail = null;
        this._service.toasterService({ type: 'error', msg: res['response']["message"] });
      }
    })
  }
  private _saveUser() {
    this._submitButtonClick.setSubmitButtonClick('clicked');
    this._loading = true;
    this.userSubmitted = true;
    if (this.userForm.invalid || (this.userSubmitted && this.userNameAvailable == null && this.toggle)) {
      this._loading = false;
      return;
    }
    let employeeDetails: any = {
      "name": {
        "first": this.userForm.value.name.firstName,
        "middle": this.userForm.value.name?.middleName,
        "last": this.userForm.value.name.lastName,
      },
      "empId": this.userForm.value.empId,
      "phone": {
        "country": this.userForm.value.contact?.number ? this.userForm.value.contact?.number?.countryCode : 'IN',
        "countryCode": this.userForm.value.contact?.number ? this.userForm.value.contact?.number?.dialCode : null,
        "number": this.userForm.value.contact?.number ? this.userForm.value.contact?.number?.number : null,
      },
      "personal": this.userForm.value.personalInfo,
      "email": this.userForm.value.contact?.email,
      "image": this.userForm.value.image,
      "userName": this.userForm.value.userName,
      "idmUserName": this.userForm.value?.idmUserName,
      "userGroup": this.userForm.value.userGroup,
      "roleId": this.userForm.value.roleId,
      "tradeId": this.userForm.value.tradeId,
      "siteId": this.userForm.controls['siteId'].value,
      "restrictedAccess": this.userForm.value.restrictedAccess,
      "supervisorId": this.userForm.value.supervisor
    }
    this._createUserSubscription = this._service.createUser(employeeDetails).subscribe((result: any) => {
      if (result["status"]) {
        if (result["response"]) {
          this._service.toasterService({ type: 'success', msg: result["response"]["message"] });
          this._activeModal.close(true);
        } else {
          // this._service.toasterService({ type: 'error', msg: result["response"]["message"] });
          this.errorMsg = result["response"]["message"];
        }
      } else {
        // this._service.toasterService({ type: 'error', msg: result["response"]["message"] });
        this.errorMsg = result["response"]["message"];
      }
    });
  }
  private _editUser(info: any) {
    this._submitButtonClick.setSubmitButtonClick('clicked');
    this._loading = true;
    this.userSubmitted = true;
    let action: any
    if (this.userValidate || this.userReValidate) {
      action = 'validate'
    } else {
      action = null;
    }
    if (info == 'rejected') {
      this.userForm.controls['userName'].clearValidators();
      this.userForm.controls['userName'].updateValueAndValidity();
      this.userForm.controls['remarks'].setValidators([Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]);
      this.userForm.controls['empId'].clearValidators();
      this.userForm.controls['empId'].updateValueAndValidity();
      this.userForm.controls['remarks'].updateValueAndValidity();
      this.userForm.controls['roleId'].clearValidators();
      this.userForm.controls['roleId'].updateValueAndValidity();
      this.userForm.controls['tradeId'].clearValidators();
      this.userForm.controls['tradeId'].updateValueAndValidity();
    }
    else if (info == 'accept') {
      this.userForm.controls['remarks'].clearValidators();
      this.userForm.controls['remarks'].updateValueAndValidity();
      this.userForm.controls['roleId'].setValidators([Validators.required]);
      this.userForm.controls['roleId'].updateValueAndValidity();
      this.userForm.controls['tradeId'].setValidators([Validators.required]);
      this.userForm.controls['tradeId'].updateValueAndValidity();
      this.userForm.controls['empId'].setValidators([Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]);
      this.userForm.controls['empId'].updateValueAndValidity();
    }

    if (this.userForm.invalid || (this.userSubmitted && this.userNameAvailable == null && this.toggle)) {
      this._loading = false;
      return;
    }
    let userDetails: any = {
      "name": {
        "first": this.userForm.value.name.firstName,
        "middle": this.userForm.value.name?.middleName,
        "last": this.userForm.value.name.lastName,
      },
      "empId": this.userForm.getRawValue().empId,
      "phone": {
        "country": this.userForm.value.contact?.number ? this.userForm.value.contact?.number?.countryCode : 'IN',
        "countryCode": this.userForm.value.contact?.number ? this.userForm.value.contact?.number?.dialCode : null,
        "number": this.userForm.value.contact?.number ? this.userForm.value.contact?.number?.number : null,
      },
      "personal": this.userForm.value.personalInfo,
      "email": this.userForm.value.contact?.email,
      "image": this.userForm.value.image,
      "userName": this.userForm.getRawValue().userName,
      "idmUserName": this.userForm.getRawValue()?.idmUserName,
      "userGroup": this.userForm.value.userGroup,
      "approverComments": this.userForm.value.remarks,
      "roleId": this.userForm.value.roleId,
      "tradeId": this.userForm.value.tradeId,
      "siteId": this.userForm.value.siteId,
      "restrictedAccess": this.userForm.value.restrictedAccess,
      "supervisorId": this.userForm.value.supervisor
    }

    // const formData: FormData = new FormData();
    // formData.append("userDetails", JSON.stringify(userDetails));
    // formData.append("userId", this.userData['_id']);
    // formData.append("action", action);
    // formData.append("registrationStatus", info);

    let formData = {};
    formData['userDetails'] = userDetails;
    formData['userId'] = this.userData['_id'];
    formData['action'] = action;
    formData['registrationStatus'] = info;

    let message: any;
    if (info == 'rejected') {
      message = Messages.REJECT_USER;
    }
    else if (info == 'accept') {
      message = Messages.ACCEPT_USER;
    }
    else {
      message = Messages.EDIT_USER;
    }
    let dialogRef = this._dialog.open(AlertDialogComponent, {
      data: { msg: message, type: null },
      panelClass: 'custom-alert-dialog',
      disableClose: true
    });
    this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._editUserSubscription = this._service.editUser(formData).subscribe((result: any) => {
          if (result["status"]) {
            if (result["response"]) {
              this._service.toasterService({ type: 'success', msg: result["response"]["message"] });
              this._activeModal.close(true);
            } else {
              // this._service.toasterService({ type: 'error', msg: result["response"]["message"] });
              this.errorMsg = result["response"]["message"];
            }
          } else {
            // this._service.toasterService({ type: 'error', msg: result["response"]["message"] });
            this.errorMsg = result["response"]["message"];
          }
        });
      }
    })


  }
  private _loadPeopleModalData() {
    if (this.userData) {
      this._patchValues(this.userData);
      this.imgURL = this.userData['image'];
      if (this.userData['credentials'][0]?.['userName']) {
        this.userForm.controls["userName"].disable();
        // this.searchSelection = this.userData['credentials'][0]?.['userId']
      }
      if (this.userData['idmUserName']) {
        this.userForm.controls["idmUserName"].disable();
      }
      if (this.userData['empId'] && !this.userValidate && !this.userReValidate) {
        this.userForm.controls["empId"].disable();
      } else {
        this.userForm.controls["empId"].enable();
      }
    }
  }
  private _countryCode: any = "+91";

  private _patchValues(x: any) {
    this._countryCode = x['phone']?.['countryCode'];
    this.userForm.patchValue({
      name: {
        firstName: x['name']?.['first'],
        middleName: x['name']?.['middle'],
        lastName: x['name']?.['last']
      }
    });
    this.userForm.patchValue({ empId: x['empId'] ? x['empId'] : null });
    this.userForm.patchValue({ roleId: x['roles'][0]?.['_id'] ? x['roles'][0]?.['_id'] : null });
    this.userForm.patchValue({ tradeId: x['trades'][0]?.['_id'] ? x['trades'][0]?.['_id'] : null });
    this.userForm.patchValue({ userName: x['credentials'][0]?.['userName'] });
    this.userForm.patchValue({ idmUserName: x['idmUserName'] });
    this.userForm.patchValue({ userGroup: x['credentials'][0]?.['userGroup'] });
    this.userForm.patchValue({
      personalInfo: {
        dob: x['personal']?.['dob'] ? x['personal']?.['dob'] : null,
        gender: x['personal']?.['gender'] ? x['personal']?.['gender'].toLowerCase() : null,
        nationality: x['personal']?.['nationality'] ? x['personal']?.['nationality'] : null,
        bloodGroup: x['personal']?.['bloodGroup'] ? x['personal']?.['bloodGroup'] : null
      }
    });


    const nums = x['phone']?.['countryCode'] ? '+' + x['phone']?.['countryCode'] + x['phone']?.['number'] : null;
    this.userForm.patchValue({
      contact: {
        country: x['phone']?.['country'] ? x['phone']?.['country'] : 'IN',
        number: x['phone']?.['number'] ? x['phone']?.['number'] : '',
        email: x['email'] ? x['email'] : '',
      }
    });
    const mapping = x['mapping'].length ? x['mapping'].find(item => item.type === 2) : null;
    this.userForm.patchValue({
      siteId: mapping ? mapping?.sites?._id : null,
      restrictedAccess: mapping ? mapping?.zones?.length ? true : false : false
    });
    if (this.userForm.controls['siteId'].value) {
      this.showSupervisor = true;
      this._getSupervisorList();
      this.userForm.patchValue({
        supervisor: x['entitysupervisor'][0]?.supervisorId
      });
      this.userForm.controls['supervisor'].disable();
    }
    (this.userValidate || this.userReValidate) ? null : this.userForm.controls['siteId'].disable();
    (this.userValidate || this.userReValidate) ? null : this.userForm.controls['restrictedAccess'].disable();
  }

  private _checkAvailabilityStatus() {
    if (this.userNameAvailable) {
      return 'fas fa-check-circle m-1 ';
    }

    else {
      return 'fas fa-times-circle m-1 '
    }

  }
  private _validateUsername() {
    return (controls: FormControl): { [key: string]: any } => {
      if ((controls.value && this._status)) {
        this.userNameAvailable = null;
        this.disableAvailableCheck = false;
        this.showText = 'Check Availability';
      } else if (!controls.value) {
        this.userNameAvailable = null;
        this.disableAvailableCheck = true;
        this.showText = 'Check Availability';
      }
      else {
        this.disableAvailableCheck = false;
      }
      return {}
    }
  }

  private _getRoleList() {
    this.roleList = [];
    this._roleListSubscription = this._service.roleList().subscribe((result: any) => {

      if (!result) {
        return;
      }
      let data;
      if (result["status"]) {
        data = result["response"]['data'];
        if (data?.length > 0) {
          this.roleList = data;
        }
      }
    });
  }

  private _getTradeList() {
    this.tradeList = [];
    this._tradeListSubscription = this._service.tradeList().subscribe((result: any) => {

      if (!result) {
        return;
      }
      let data;
      if (result["status"]) {
        data = result["response"]['data'];
        if (data?.length > 0) {
          this.tradeList = data;
        }
      }
    });
  }

  /**
   * Gets user group
   */
  private _getUserGroup() {
    const filterPayload: { status?: boolean; type?: 'all' | 'level'; } = {
      type: 'level'
    };
    this._userGroupPeopleSubscription = this._service.getUserGroups(filterPayload)
    .subscribe({
      next: (result) => {
        this.userGroupList = result;
      }, error: (error: any) => {
          this.userGroupList = [];
        }
    });
  }
}
